// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] || chunkId) + "-" + {"678":"e688509887ac64d0ee1f","731":"e307395e4ce1b5bf2cf7","843":"382a3cf8bb7ccf5bfcc8","883":"4ac0059453811743a889"}[chunkId] + ".js";
};